import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { Commands } from "./commands";
import { CommandDetail } from "./command";

interface Props {
  itemLink: string;
  containerName?: string;
}
export const CommandsRoute: React.FC<Props> = ({ itemLink, containerName }) => {
  return (
    <Routes>
      <Route index element={<Commands selfLink={itemLink} />} />
      <Route path={`:commandId`} element={<CommandDetail itemLink={itemLink} containerName={containerName} />} />
    </Routes>
  );
};
